import React from "react";
import UiContentCard from "../../../components/cards/UiContentCard";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import Volvo from "../../../../../styles/img/campaigns/volvo-ex90.jpg"
import { UiSpaceLeft } from "../../../components/common/UiSpaceLeft";

export const YourOtherGoals = () => {
    const MoreButton = () => {
    }
    return (
        <>

            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-other-goals-sec">
                    <UiCol lg="12">
                        <UiCardTitle title="Your Other Goals" />
                    </UiCol>
                    <UiCol lg="3">
                        <UiContentCard
                            cardImg={Volvo}
                            heading="New York Trip"
                            MoreButton={MoreButton}
                            MoreButtonTitle="Buy Now 20 Points"
                            body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                        />
                    </UiCol>

                    <UiCol lg="3">
                        <UiContentCard
                            cardImg={Volvo}
                            heading="New York Trip"
                            MoreButton={MoreButton}
                            MoreButtonTitle="Buy Now 20 Points"
                            body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                        />
                    </UiCol>

                    <UiCol lg="3">
                        <UiContentCard
                            cardImg={Volvo}
                            heading="New York Trip"
                            MoreButton={MoreButton}
                            MoreButtonTitle="Buy Now 20 Points"
                            body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                        />
                    </UiCol>

                    <UiCol lg="3">
                        <UiSpaceLeft
                            title="1 Space Left"
                            spcButton="Add Goal"
                            spcButtonAction={MoreButton}
                        />
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>

        </>
    )
}